/* tslint:disable */
import {CHART_TYPE} from '../../DoraData/data-base';
import * as Highstock from 'highcharts/highstock';
import {SeriesOptionsType, XAxisOptions} from 'highcharts/highstock';
import {DataSeries} from '../../DoraData/data-series';
import {ChartOption} from './Data/chart-option';
import {DoraNumber} from '../../Utility/dora-number';
import {ChartBuilderBase} from './chart-builder-base';
import {formatDate} from '@angular/common';

declare function DoraGetLocale(): string;

export class ChartStockBuilder extends ChartBuilderBase {
    private chartType: CHART_TYPE = null;
    public chart: typeof Highstock = Highstock;
    public chartOptions: Highstock.Options = {};
    private xAxis: ChartOption[] = [];
    private yAxis: ChartOption[] = [];
    private legend: ChartOption[] = [];
    private tooltip: ChartOption[] = [];
    private scrollbar: ChartOption[] = [];
    private navigator: ChartOption[] = [];
    private rangeSelector: ChartOption[] = [];
    private seriesPlotOptions: ChartOption[] = [];
    private seriesList: DataSeries[];
    public title = '';
    private customToolTip = false;
    private outputFormat: string;
    private outputFormatFromData: boolean;
    private customToolTipShowPercentageFromFirst = false;
    private yRangeMaxPercentage: number = null;
    private yRangeMinPercentage: number = null;

    constructor(chartType: CHART_TYPE, graphSkinConfiguration: string,
                seriesList: DataSeries[],
                chart: ChartOption[],
                legend: ChartOption[],
                tooltip: ChartOption[],
                scrollbar: ChartOption[],
                navigator: ChartOption[],
                rangeSelector: ChartOption[],
                locale: string,
                xAxis: ChartOption[], yAxis: ChartOption[],
                yRangeMaxPercentage: number,
                yRangeMinPercentage: number,
                plotOptionsForType: ChartOption[],
                seriesPlotOptions: ChartOption[],
                title: string,
                customToolTip: boolean,
                customToolTipShowPercentageFromFirst: boolean,
                outputFormat: string,
                outputFormatFromData: boolean) {

        super(locale);

        // check data
        if (seriesList.length === 0) {
              return;
          }

        this.chartType = chartType;
        this.chartOptions = JSON.parse(graphSkinConfiguration);
        this.xAxis = xAxis;
        this.yAxis = yAxis;
        this.yRangeMaxPercentage = yRangeMaxPercentage;
        this.yRangeMinPercentage = yRangeMinPercentage;
        this.legend = legend;
        this.tooltip = tooltip;
        this.scrollbar = scrollbar;
        this.navigator = navigator;
        this.rangeSelector = rangeSelector;
        this.title = title;
        this.customToolTip = customToolTip;
        this.customToolTipShowPercentageFromFirst = customToolTipShowPercentageFromFirst;
        this.outputFormat = outputFormat;
        this.outputFormatFromData = outputFormatFromData;
        this.seriesPlotOptions = seriesPlotOptions;

        switch (this.chartType) {
          case CHART_TYPE.STOCKLINEAR:
            this.chartOptions.chart.type = 'line';
            this.chartOptions.plotOptions = {column: {stacking: 'normal'}};
            this.setOptions(this.chartOptions, 'plotOptions', plotOptionsForType);
            break;
          case CHART_TYPE.STOCKAREASPLINE:
            this.chartOptions.chart.type = 'areaspline';
            this.chartOptions.plotOptions = {column: {stacking: 'normal'}};
            this.setOptions(this.chartOptions, 'plotOptions', plotOptionsForType);
            break;
          case CHART_TYPE.STOCKAREA:
//            this.setOption(this.chartOptions, 'chart', ChartOption.create('type', 's', 'area'));
            this.chartOptions.chart.type = 'area';
            this.chartOptions.plotOptions = {column: {stacking: 'normal'}};
            this.setOptions(this.chartOptions, 'plotOptions', plotOptionsForType);
            break;
        }

        this.setOptions(this.chartOptions, 'chart', chart);

        this.createSingleChart(seriesList);
    }

    public getSVG(chartIdx: number): string {
        return this.chart.charts.filter(chart => chart !== undefined)[chartIdx].getSVG();
        // const chartToPrint: Chart = this.chart.charts.find(chart => chart !== undefined);
        //
        // if (chartToPrint !== undefined) {
        //     return chartToPrint.getSVG();
        // } else {
        //     return '';
        // }
    }
    public export(outputType: string): void {
        this.chart.charts.forEach(chartToPrint => {
            if (chartToPrint !== undefined) {
                const exportingOptions: any = this.chart.getOptions().exporting;

                // set output type
                exportingOptions.type = outputType;
                chartToPrint.exportChart(exportingOptions, this.chart.getOptions());

                console.log('Print finished');
            }
        });
    }

    private setYAxisMinMax(seriesList: DataSeries[], rangeMaxPercentage: number, rangeMinPercentage: number): void {
      let min = null;
      let max = null;

      // different min and max for single and compare chart
      if (seriesList.length == 1) {
        // check range in series
        if (seriesList[0].RangeMin !== null && seriesList[0].RangeMax !== null) {
          min = seriesList[0].RangeMin;
          max = seriesList[0].RangeMax;
        } else  {
          min = seriesList[0].getMinValue();
          max = seriesList[0].getMaxValue();

          if (rangeMaxPercentage !== null && rangeMinPercentage !== null) {
            // calculate min and max
            min -= min * rangeMinPercentage / 100;
            max += max * rangeMaxPercentage / 100;
          }
        }
      } else {
        // compare chart: values must be translated in percentage


        seriesList.forEach(series => {
          if (series.DataRows.length === 0) {
            console.warn('Series vuota');
            return;
          }

          let minValue = series.getMinValue();
          let maxValue = series.getMaxValue();
          if (minValue === 0) {
            console.warn('Series contiene almeno un valore a 0');
          }

          if (!series.FixedSeries) {
            // calculate percentage
            let firstValue = series.DataRows[0].DataTuplas[1].Value;
            if (firstValue === 0) {
              console.warn('Primo elemento della series a 0');
            }

            if (firstValue === 0) {
              maxValue = 200;
              minValue = 0;
            } else {
              minValue = 100 + ((100 - (minValue * 100 / firstValue)) * -1);
              maxValue = 100 + ((100 - (maxValue * 100 / firstValue)) * -1);
              // add range if any
              if (rangeMaxPercentage !== null && rangeMinPercentage !== null) {
                minValue -= rangeMinPercentage;
                maxValue += rangeMaxPercentage;
              }
            }
          } else {
            // fixed series: value is percentage apply ranges
            minValue -= rangeMinPercentage;
            maxValue += rangeMaxPercentage;
          }


          // check min
          if (min === null || minValue < min) {
            min = minValue;
          }

          // check max
          if (max === null || maxValue > max) {
            max = maxValue;
          }
        });
      }

      // set min and max
      this.yAxis.push(ChartOption.create('min', 'n', min));
      this.yAxis.push(ChartOption.create('max', 'n', max));
    }
    private createSingleChart(seriesList: DataSeries[]): void {
      this.seriesList = seriesList;

      // clone options
      const chartOptions: Highstock.Options = this.chartOptions;

      // set language constants
      this.setLanguage(chartOptions);

      const compareChart = this.seriesList.length > 1;

      // set min and max for YAxis
      this.setYAxisMinMax(seriesList, this.yRangeMaxPercentage, this.yRangeMinPercentage);

      // todo questo non serve più: è calcolato da codice custom
      // compare chart: unset
      this.setOption(chartOptions, 'plotOptions', ChartOption.create('series\\compare', 's', ''));



      // Grouping
      // this.setOption(chartOptions, 'plotOptions', ChartOption.create('series\\dataGrouping\\approximation', 's', 'average'));
      // this.setOption(chartOptions, 'plotOptions', ChartOption.create('series\\dataGrouping\\enabled', 'b', 'true'));
      // this.setOption(chartOptions, 'plotOptions', ChartOption.create('series\\dataGrouping\\forced', 'b', 'true'));
      // this.setOption(chartOptions, 'plotOptions', ChartOption.create('series\\dataGrouping\\groupPixelWidth', 'n', '10'));


      // if (compareChart) {
      //   // compare chart: set percentage
      //   this.setOption(chartOptions, 'plotOptions', ChartOption.create('series\\compare', 's', 'percent'));
      // } else {
      //   // compare chart: unset
      //   this.setOption(chartOptions, 'plotOptions', ChartOption.create('series\\compare', 's', ''));
      // }

      // set title
      this.setOption(chartOptions, 'title', ChartOption.create('text', 's', this.title));

      const xAxisOption: XAxisOptions = {};
      xAxisOption.categories = [];

      seriesList[0].TuplasDescription.forEach(tuplaDescription => {
          xAxisOption.categories.push(tuplaDescription.Name);
      });
      chartOptions.xAxis = xAxisOption;

      let firstUnit = '';

      let firstSeries = true;

      seriesList.forEach((dataSeries, index) => {
          if (firstUnit === '') {
            firstUnit = dataSeries.Units;
          }
          let secondSeries = false;
          let chartType = this.chartType;
          // if (dataSeries.Units !== firstUnit) {
          //   chartType = CHART_TYPE.LINEAR;
          //   secondSeries = true;
          // }

          if (index > 0) {
            // type of second series
            if (this.chartType == CHART_TYPE.STOCKAREASPLINE){
              chartType = CHART_TYPE.SPLINE;
            } else {
              chartType = CHART_TYPE.LINEAR;
            }
          }

          const chartSeriesElement: SeriesOptionsType =   this.getSeriesOptions(chartType);

          if (chartType === CHART_TYPE.STOCKAREA || chartType === CHART_TYPE.STOCKAREASPLINE) {
            this.setOptions(chartSeriesElement, null, this.seriesPlotOptions);
            // chartSeriesElement['fillColor'] = '0.0,0.0,0.0,1.0,0.0,#ffffff,1.0,#0000ff';
          }
          chartSeriesElement.name = dataSeries.Description;

          // @ts-ignore
          // this is always false: in case of more than one series, the axis unit is '%' because it is a compare chart
          chartSeriesElement.yAxis = secondSeries === true ? 1 : 0;

          chartSeriesElement.tooltip = {valueSuffix: ' ' + dataSeries.Units};
          chartSeriesElement.data = [];

          // set custom settings for tooltip
          chartSeriesElement['customFixedSeries'] = dataSeries.FixedSeries;
          chartSeriesElement['customCompareChart'] = compareChart;
          chartSeriesElement['customToolTipShowPercentageFromFirst'] = this.customToolTipShowPercentageFromFirst;
          chartSeriesElement['customFirstValue'] = dataSeries.FirstValue;
          // add color if present
          if (dataSeries.Color !== undefined && dataSeries.Color !== null) {
            chartSeriesElement.color = dataSeries.Color;
          }

          if (dataSeries.DataRows.length > 0) {
            const firstValue = dataSeries.FirstValue;
//            const firstValue = dataSeries.DataRows[0].DataTuplas[1].Value;

            dataSeries.DataRows.forEach(dataRow => {

              // tslint:disable-next-line:ban-types
              const data = [];

              // push date in time format
              let date: Date = null;
              date = dataRow.DataTuplas[0].Value;
              data.push(date.getTime());
              // push value
              if (compareChart) {
                // compare chart
                // in case of fixed series, the value is the percentage, in case of normal series calculate the percentage
                // tslint:disable-next-line:ban-types
                const percentage = dataSeries.FixedSeries ? dataRow.DataTuplas[1].Value : 100 + ((100 - (dataRow.DataTuplas[1].Value * 100 / firstValue)) * -1);
                data.push(percentage);
              } else {
                data.push(dataRow.DataTuplas[1].Value);
              }


              // Improperly use of className to set outputFormat
              data['className'] =
                dataRow.DataTuplas[1].OutputFormat === undefined ? this.outputFormat : dataRow.DataTuplas[1].OutputFormat;
              chartSeriesElement.data.push(data);

              // chartSeriesElement.data.push(dataRow.DataTuplas[1].Value);

              // Save original value
              data['customOriginalValue'] = dataRow.DataTuplas[1].Value;
            });

            chartOptions.series.push(chartSeriesElement);
          }
      });

      // Axis options
      this.setOptions(chartOptions, 'xAxis', this.xAxis);
      this.setOptions(chartOptions, 'yAxis', this.yAxis);
      this.chartOptions.yAxis[0].labels.formatter = this.yAxisFormatter;

      // legend
      this.setOptions(chartOptions, 'legend', this.legend);

      // tooltip generic
      this.setOptions(chartOptions, 'tooltip', this.tooltip);
      // tooltip
      if (chartOptions.tooltip === undefined) {
          chartOptions.tooltip = {};
      }
      if (this.customToolTip) {
        this.chartOptions.tooltip.useHTML = true;
        this.chartOptions.tooltip.formatter = this.toolTipFormatter;
      }

      // scrollbar
      this.setOptions(chartOptions, 'scrollbar', this.scrollbar);

      // navigator
      this.setOptions(chartOptions, 'navigator', this.navigator);

      // rangeSelector
      this.setOptions(chartOptions, 'rangeSelector', this.rangeSelector);

      this.chart.setOptions(chartOptions);
    }

  //<editor-fold desc="Formatters">

    private yAxisFormatter(): string {
      let result = '';


      // @ts-ignore
      if (this.axis.series.length > 1) {
        // @ts-ignore
        const numberFormat = this.chart.userOptions.yAxis[0].labels.formatCompare;

        // @ts-ignore
        result += DoraNumber.formatNumber(this.value, null, numberFormat) + ' ';

        result += '%';
      } else {
        // @ts-ignore
        const numberFormat = this.chart.userOptions.yAxis[0].labels.format;

        // @ts-ignore
        result += DoraNumber.formatNumber(this.value, null, numberFormat) + ' '

        // @ts-ignore
        result += this.axis.series[0].userOptions.tooltip.valueSuffix;
      }

      return result;
    }
  private toolTipFormatter(): false | string | Array<string> {

    // @ts-ignore
//    const serieName = this.series.getName();
    let result = '<div class="tooltip-container">';

    // get date from first point
    // @ts-ignore
    const firstPoint = this.points[0];


    // get current date
    // @ts-ignore
    const date = new Date(this.x);

    result += '<div class="date">' + formatDate(date, 'shortDate', DoraGetLocale());
    if ( firstPoint.series.currentDataGrouping !== undefined && firstPoint.series.currentDataGrouping.unitName !== 'day') {
      // it is a range: calculate end date escluding 1 day
      // @ts-ignore
      const endDate = new Date(this.x + firstPoint.series.currentDataGrouping.totalRange - 86400000);
      result += ' - ' + formatDate(endDate, 'shortDate', DoraGetLocale());
    }

    result += '</div>';




    // @ts-ignore
    this.points.forEach(point => {
      // point attribute
      // point.series.options.data[point.point.index].className
      //point.point.series.options.joeparam

      // @ts-ignore
      const flCompare = point.point.series.options.customCompareChart;

      // @ts-ignore
      const flFixedSeries = point.point.series.options.customFixedSeries;

      const firstValue = point.point.series.options.customFirstValue;

      // get number format
      let outputFormat = point.series.options.data[point.point.index].className;

      // first point
      let firstPoint = point.series.options.data[0].customOriginalValue;

      // @ts-ignore
      result += '<div class="name" style="color:' + point.color + ';">' + point.series.getName() + '</div>';

      result += '<div class="value-container">';
      // @ts-ignore
      if (point.series.tooltipOptions.valuePrefix !== undefined) {
        // @ts-ignore
        result += '<span class="valuePrefix">' + point.series.tooltipOptions.valuePrefix + '</span>';
      }

      // @ts-ignore
      if (!flCompare) {

        result += '<span class="value">' +

          // @ts-ignore
          DoraNumber.formatNumber(point.y,
            null,
            outputFormat) + '</span>';

        // @ts-ignore
        if (point.series.tooltipOptions.valueSuffix !== undefined) {
          // @ts-ignore
          result += '<span class="valueSuffix">' + point.series.tooltipOptions.valueSuffix + '</span>';
        }

        // show percentage from first point
        if (point.point.series.options.customToolTipShowPercentageFromFirst === true) {
          let percentageFromFirstPoint = (point.y-firstValue) * 100 / firstValue;

          // value
          result += '<span class="compare-value ' + (percentageFromFirstPoint >= 0 ? 'pos' : 'neg') + '">' +
            // @ts-ignore
            DoraNumber.formatNumber(percentageFromFirstPoint,
              null,
              outputFormat) + '</span>';

          // unit
          result += '<span class="compare-value-suffix ' + (percentageFromFirstPoint >= 0 ? 'pos' : 'neg') +  '">%</span>';

        }

      } else {
        // compare chart

        if (!flFixedSeries){
          // add value
          result += '<span class="value">' +

            // @ts-ignore
            DoraNumber.formatNumber( point.series.options.data[point.point.index].customOriginalValue,
              null,
              outputFormat) + '</span>';

          // @ts-ignore
          if (point.series.tooltipOptions.valueSuffix !== undefined) {
            // @ts-ignore
            result += '<span class="valueSuffix">' + point.series.tooltipOptions.valueSuffix + '</span>';
          }
        }

        // add percentage
        const percentage = point.y;

        const percentageClass = percentage >= 100 ? 'pos' : 'neg';
        // @ts-ignore
        result += '<span class="compare-value '  + percentageClass + '">' +

          // @ts-ignore
          DoraNumber.formatNumber(percentage - 100,
            null,
            outputFormat) + '</span>';

        result += '<span class="compare-value-suffix ' + percentageClass +  '">%</span>';
      }



      result += '</div>';

    });




    // // @ts-ignore
    // result += '<div class="column-name">' + this.point.name + '</div>';
    // // @ts-ignore
    // result += '<div class="name" style="color:' + this.color + ';">' + serieName + '</div>';
    //
    // result += '<div class="value-container">';
    //
    // // @ts-ignore
    // if (this.series.tooltipOptions.valuePrefix !== undefined) {
    //   // @ts-ignore
    //   result += '<span class="valuePrefix">' + this.series.tooltipOptions.valuePrefix + '</span>';
    // }
    //
    // // get number format
    // let outputFormat = '###,###,###.##';
    //
    // // @ts-ignore
    // // tslint:disable-next-line:prefer-for-of
    // for (let i = 0; i < this.series.options.data.length; i++) {
    //   // @ts-ignore
    //   if (this.series.options.data[i][0] === this.point.name) {
    //     // @ts-ignore
    //     outputFormat = this.series.options.data[i].className;
    //     break;
    //   }
    // }
    //
    // result += '<span class="value">' +
    //
    //
    //
    //   // @ts-ignore
    //   DoraNumber.formatNumber(this.y,
    //     null,
    //     outputFormat) + '</span>';
    //
    // // @ts-ignore
    // if (this.series.tooltipOptions.valueSuffix !== undefined) {
    //   // @ts-ignore
    //   result += '<span class="valueSuffix">' + this.series.tooltipOptions.valueSuffix + '</span>';
    // }
    //
    // result += '</div>';
    result += '</div>';

    return result;
  }

  //</editor-fold>
  private getUnit(seriesName: string): string {
      return 'ciao';
  }

  /**
   * Get specific chartoptions depending on chartType
   * @param chartType type of chart
   */
  private getSeriesOptions(chartType: CHART_TYPE): SeriesOptionsType {
        switch (chartType) {
            case CHART_TYPE.COLUMN:
            case CHART_TYPE.COLUMNSTACK:
                return {type: 'column'};
            case CHART_TYPE.LINEAR:
                return {type: 'line'};
            case CHART_TYPE.SPLINE:
                return {type: 'spline'};
            case CHART_TYPE.BAR:
                return {type: 'bar'};
            case CHART_TYPE.PIE:
                return {type: 'pie'};
            case CHART_TYPE.STOCKLINEAR:
              return {type: 'line'};
            case CHART_TYPE.STOCKAREA:
              return {type: 'area'};
            case CHART_TYPE.STOCKAREASPLINE:
              return {type: 'areaspline'};
            default:
                return {type: 'line'};
        }
    }

  // tslint:disable-next-line:ban-types
    private testyAxis(dst: Object): void {
      dst['chart']['marginRight'] = 200;
      dst['yAxis'] = [];
      dst['yAxis'][0] = {};
      dst['yAxis'][1] = {};
      dst['yAxis'][0]['gridLineColor'] = '#197F07';
      dst['yAxis'][1]['opposite'] = true;
      dst['yAxis'][1]['title'] = {};
      dst['yAxis'][1]['title']['text'] = 'secondo valore';
      dst['yAxis'][1]['labels'] = {};
      dst['yAxis'][1]['labels']['enabled'] = true;
      dst['yAxis'][1]['labels']['padding'] = 20;
      dst['yAxis'][1]['labels']['margin'] = 20;
    }
    // tslint:disable-next-line:ban-types
    private setOptions(dst: Object, root: string, options: ChartOption[]): void {
        // if (dst[root] === undefined) {
        //     dst[root] = {};
        // }
        options.forEach((option: ChartOption) => {
            option.setOption(dst, root);
        });
    }


}
